import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { OregonWellDataService } from '../../../services/oregon-well-data.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { HouseholdService } from 'app/services/household-service';
import { IHousehold } from 'app/models/household/household';
import { DialogEditHouseholdComponent } from '../edit/household-edit-dialog';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { DialogMergeHouseholdsComponent } from './merge-households-dialog-component';
import { HousingUnitService } from 'app/services/housingunit-service';
import { AuthService } from '@shared/auth/auth.service';
import { IFuzzySearchHouseholdResult, IFuzzySearchResult } from 'app/models/common/fuzzySearchResult';

@Component({
  selector: 'app-search-households',
  templateUrl: './search-households.component.html',
  styleUrls: ['./search-households.component.scss']
})
export class SearchHouseholdsComponent implements OnInit, AfterViewInit {
  pageSize = 20;
  processing = false;
  showResults = false;
  checkboxActionList: number[] = [];

  displayedColumns: string[] = ['selectRow', 'id', 'contactName', 'address1', 'city', 'zip', 'county', 'waterTreamentProvided', 'bottledWaterProvided', 'personsInHousehold', 'score'];
  flatResults: IHousehold[] = [];
  dataSource = new MatTableDataSource<IHousehold>(this.flatResults);
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  filterTable(event: Event) {
    let value = (event.target as HTMLInputElement).value;
    this.dataSource.filter = value.trim().toLowerCase();
  }

  constructor(public dialog: MatDialog,
    public householdService: HouseholdService,
    public housingUnitService: HousingUnitService,
    public oregonWellDataService: OregonWellDataService,
    public authService: AuthService,
    private toastr: ToastrService) {
  }

  ngAfterViewInit(): void {
    // ngAfterViewInit
  }

  ngOnInit(): void {
    if (this.searchResultsCount > 0) {
      this.onSubmit();
    }
  }

  openMergeDialog() {
    //let items = this.householdService.searchResults.filter(w => this.checkboxActionList.indexOf(w.data.id) >= 0);
    let items = this.householdService.searchResults.filter(w => this.checkboxActionList.indexOf(Number(w.data.id)) >= 0).map((result: any) => {
      return {
        id: result.data?.id || null,
        contactName: result.data?.contactName || null,
        address1: result.data?.address1 || null,
        address2: result.data?.address2 || null,
        city: result.data?.city || null,
        state: result.data?.state || null,
        zip: result.data?.zip || null,
        county: result.data?.county || null,
        waterTreamentProvided: result.data?.waterTreamentProvided || null,
        bottledWaterProvided: result.data?.bottledWaterProvided || null,
        comments: result.data?.comments || null,
        personsInHousehold: result.data?.personsInHousehold || null,
      } as any;
    });

    if (items != undefined && items.length > 0) {
      const dialogRef = this.dialog.open(DialogMergeHouseholdsComponent, {
        width: '1080px',
        data: { items: items, type: this.householdService.search.searchBy },
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result != "Cancel" && result != "Close") {
          this.onSubmit();
        }
      });
    }
  }

  clickCheckboxAction(id: number) {
    let idx = this.checkboxActionList.indexOf(id)
    if (idx >= 0) {
      this.checkboxActionList.splice(idx, 1);
    }
    else {
      this.checkboxActionList.push(id);
    }
  }

  edit(householdId: number) {
    const dialogRef = this.dialog.open(DialogEditHouseholdComponent, {
      width: '90%',
      data: householdId,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.onSubmit();
    });
  }

  download() {
    this.setFormFields();

    if (this.householdService.search.searchBy == this.householdService.householdText) {
      let csvOptions = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalseparator: '.',
        showLabels: false,
        showTitle: false,
        title: '',
        useBom: false,
        noDownload: false,

        // this order is the CSV layout
        // the headers match & are defined in: HouseholdSearchResultDto object
        headers: [
          "Id", "ContactName", "ContactEmail", "ContactPhone", "ContactCellPhone",
          "PreferredContactMethod", "Address1", "Address2", "AddressUnitNumber",
          "City", "State", "Zip", "County", "Latitude", "Longitude",
          "MailingAddress", "MailingCity", "MailingState", "MailingZip",
          "Comments", "Eligible", "RequestedConfidentiality", "LearnedOfTesting", "SharedWell", "CountyTestedWell",
          "NitrateStripResult", "HouseholdRelyOnWell", "WaterTreamentProvided", "BottledWaterProvided",
          "PersonsInHousehold", "NumberOfHouseholds", "InfantsInHousehold", "PregnancyInHousehold", "Age15AndBelow",
          "Age16AndAbove", "TranslationNeeded", "Language"
        ]
      };

      this.householdService.downloadCsv(this.householdService.search).subscribe(
        result => {
          this.processing = false;
          return new AngularCsv(result, "Household_Search_Export", csvOptions);
        },
        error => {
          this.processing = false;
        }
      );
    }
    else {
      let csvOptions = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalseparator: '.',
        showLabels: false,
        showTitle: false,
        title: '',
        useBom: false,
        noDownload: false,

        // this order is the CSV layout
        // the headers match & are defined in: HousingUnitSearchResultDto object
        headers: [
          "Id", "ContactName", "ContactEmail", "ContactPhone", "ContactCellPhone",
          "PreferredContactMethod", "OwnerFirstName", "OwnerLastName", "OwnerEmail",
          "Address1", "Address2", "UnitNumber", "City",
          "State", "Zip", "County", "Latitude", "Longitude",
          "MailingAddress", "MailingCity", "MailingState", "MailingZip", "Comments",
          "AcceptedServices", "OhaComments", "SourceComments", "SourceID",
          "HousingUnitDataSource ", "TaxLotId", "TaxLot", "Acres",
          "UnitType", "Municipality", "Map"
        ]
      };

      this.housingUnitService.downloadCsv(this.householdService.search).subscribe(
        result => {
          this.processing = false;
          return new AngularCsv(result, "HousingUnit_Search_Export", csvOptions);
        },
        error => {
          this.processing = false;
        }
      );
    }
  }

  reset() {
    let previousSearchBy = this.householdService.searchForm.get('searchBy').value;

    this.householdService.searchForm.reset({
      id: '',
      contactName: '',
      address1: '',
      city: '',
      zip: '',
      county: '',
      personsInHousehold: 0,
      pregnancyInHousehold: false,
      waterTreamentProvided: false,
      bottledWaterProvided: false,
      infantsUnder1: false,
      age1to4: false,
      age5to9: false,
      age10to14: false,
      age15to19: false,
      age20to29: false,
      age30to39: false,
      age40to49: false,
      age50to59: false,
      age60to69: false,
      age70to79: false,
      age80Plus: false,
      age15AndBelow: false,
      age16AndAbove: false,
      infantsInHousehold: false,
      searchBy: ''
    });

    this.householdService.searchForm.get('searchBy').setValue(previousSearchBy);
  }

  onSubmit() {
    this.checkboxActionList = [];
    this.setFormFields();
    this.processing = true;
    this.showResults = false;

    this.householdService.Search(this.householdService.search).subscribe(
      result => {
        this.householdService.searchResults = result;
        this.householdService.haveSearchResults = true;
        this.householdService.searchResultsCount = this.householdService.searchResults.length;
        this.searchResultsCount = this.householdService.searchResults.length;
        this.processing = false;
        this.showResults = true;
      },
      error => {
        this.processing = false;
        this.showResults = false;
      },
      () => {
        if (this.householdService.search.searchBy == this.householdService.householdText) {
          this.displayedColumns = ['selectRow', 'id', 'contactName', 'address1', 'city', 'zip', 'county', 'waterTreamentProvided', 'bottledWaterProvided', 'personsInHousehold', 'score'];
        }
        else {
          this.displayedColumns = ['selectRow', 'id', 'contactName', 'address1', 'city', 'zip', 'county', 'numberOfHouseholds', 'score'];
        }

        this.flatResults = this.getFlatSearchResults();
        this.dataSource = new MatTableDataSource<IHousehold>(this.flatResults);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  getFlatSearchResults(): any[] {
    return this.householdService.searchResults.map((result: IFuzzySearchHouseholdResult) => {
      return {
        id: result.data?.id || null,
        contactName: result.data?.contactName || null,
        contactEmail: result.data?.contactEmail || null,
        contactPhone: result.data?.contactPhone || null,
        contactCellPhone: result.data?.contactCellPhone || null,
        preferredContactMethod: result.data?.preferredContactMethod || null,
        address1: result.data?.address1 || null,
        address2: result.data?.address2 || null,
        addressUnitNumber: result.data?.addressUnitNumber || null,
        city: result.data?.city || null,
        state: result.data?.state || null,
        zip: result.data?.zip || null,
        county: result.data?.county || null,
        waterTreamentProvided: result.data?.waterTreamentProvided || null,
        bottledWaterProvided: result.data?.bottledWaterProvided || null,
        personsInHousehold: result.data?.personsInHousehold || null,
        numberOfHouseholds: result.data?.numberOfHouseholds || null,
        score: result.score || 0
      } as any;
    });
  }

  setFormFields() {
    this.householdService.search.id = this.householdService.searchForm.value.id;
    this.householdService.search.contactName = this.householdService.searchForm.value.contactName;
    this.householdService.search.county = this.householdService.searchForm.value.county;
    this.householdService.search.address1 = this.householdService.searchForm.value.address1;
    this.householdService.search.city = this.householdService.searchForm.value.city;
    this.householdService.search.zip = this.householdService.searchForm.value.zip;
    this.householdService.search.county = this.householdService.searchForm.value.county;
    this.householdService.search.pregnancyInHousehold = this.householdService.searchForm.value.pregnancyInHousehold;
    this.householdService.search.infantsUnder1 = this.householdService.searchForm.value.infantsUnder1;
    this.householdService.search.infantsInHousehold = this.householdService.searchForm.value.infantsInHousehold;
    this.householdService.search.age1to4 = this.householdService.searchForm.value.age1to4;
    this.householdService.search.age5to9 = this.householdService.searchForm.value.age5to9;
    this.householdService.search.age10to14 = this.householdService.searchForm.value.age10to14;
    this.householdService.search.age15to19 = this.householdService.searchForm.value.age15to19;
    this.householdService.search.age20to29 = this.householdService.searchForm.value.age20to29;
    this.householdService.search.age30to39 = this.householdService.searchForm.value.age30to39;
    this.householdService.search.age40to49 = this.householdService.searchForm.value.age40to49;
    this.householdService.search.age50to59 = this.householdService.searchForm.value.age50to59;
    this.householdService.search.age60to69 = this.householdService.searchForm.value.age60to69;
    this.householdService.search.age70to79 = this.householdService.searchForm.value.age70to79;
    this.householdService.search.age80Plus = this.householdService.searchForm.value.age80Plus;
    this.householdService.search.age15AndBelow = this.householdService.searchForm.value.age15AndBelow;
    this.householdService.search.age16AndAbove = this.householdService.searchForm.value.age16AndAbove;
    this.householdService.search.waterTreamentProvided = this.householdService.searchForm.value.waterTreamentProvided;
    this.householdService.search.bottledWaterProvided = this.householdService.searchForm.value.bottledWaterProvided;
    this.householdService.search.searchBy = this.householdService.searchForm.value.searchBy;
  }

  searchResults(): IFuzzySearchHouseholdResult[] {
    return this.householdService.searchResults;
  }

  searchResultsCount = this.householdService.searchResultsCount;
}